import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  MenuItem,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import React, {
  Dispatch,
  Fragment,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useRecoilValue } from 'recoil';
import { useQuery } from 'react-query';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import { useSession } from '../../hooks/session';
import { schoolListState } from '../../common/atom';
import {
  educationOffices,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  schoolGroups,
} from '../../common/helper';

const DEFAULT_WIDTH = '8rem';
interface Props {
  tabValue: number;
  educationOfficeInfo: any;
  setEducationOfficeInfo: Dispatch<React.SetStateAction<any>>;
  onChangeTab?: (data: number) => void;
  showEducationOffice?: boolean;
}

export const SwEducationOfficeStatTab: React.FC<Props> = ({
  tabValue,
  educationOfficeInfo,
  setEducationOfficeInfo,
  onChangeTab,
  showEducationOffice = true,
}) => {
  const navigate = useNavigate();
  const { loginVal } = useSession();
  const [saveTabValue, setSaveTabValue] = useState<number>(tabValue);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(
    loginVal.value.user.educationOfficeSeq !== 0
      ? loginVal.value.user.educationOfficeSeq
      : 0
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSaveTabValue(newValue);

    switch (newValue) {
      case 0:
        navigate('/educationofficestat/schoolstat');
        break;
      case 1:
        navigate('/educationofficestat/schoolrank');
        break;
      case 2:
        navigate('/educationofficestat/educationofficestatistics');
        break;
      case 3:
        navigate('/educationofficestat/educationofficelogmanage');
        break;
      default:
        navigate('/educationofficestat');
    }
  };

  useEffect(() => {
    const newEducationOffice = educationOffices.filter(
      (s: any) => s.seq === educationOfficeSeq
    );
    const newData: any = {
      educationOfficeSeq: educationOfficeSeq,
      educationOfficeName:
        newEducationOffice !== null && newEducationOffice.length > 0
          ? newEducationOffice[0].name
          : '전체',
    };
    setEducationOfficeInfo(newData);
  }, [educationOfficeSeq]);

  return (
    <Box>
      <Box
        className='flex_between'
        sx={{ mb: '2rem', borderBottom: 1, borderColor: 'divider' }}
      >
        <Tabs value={saveTabValue} onChange={handleChange}>
          <Tab label='학교 관리' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='학교별 랭킹' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='통계' sx={{ width: DEFAULT_WIDTH }} />
          <Tab label='로그(글) 관리' sx={{ width: DEFAULT_WIDTH }} />
        </Tabs>
        {showEducationOffice && (
          <TextField
            disabled={
              loginVal.value.user.roleName === '일반' ||
              loginVal.value.user.roleName === '관리자1' ||
              (loginVal.value.user.roleName === '관리자2' &&
                loginVal.value.user.educationOfficeSeq !== undefined &&
                loginVal.value.user.educationOfficeSeq !== null)
            }
            sx={{ width: '10rem', mr: '.5rem' }}
            select
            value={educationOfficeSeq}
            onChange={evt => setEducationOfficeSeq(Number(evt.target.value))}
          >
            {educationOffices.map((item: any, idx: number) => (
              <MenuItem key={`educatin_office_${idx}`} value={item.seq}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Box>
    </Box>
  );
};
